<template>
    <div>
        <button
                class="InterTableButton"
                :class="[
                        icon,
                        'fi ' + styleBtn,
                        { 'disabled': !enabled }
                     ]"
                :disabled="!enabled"
                v-on:click.prevent="onClick">
        </button>

        <inter-modal
                title-icon="flaticon-info"
                :buttonPrimary="buttons.primary"
                :buttonSecondary="buttons.secondary"
                :title="confirmTitle"
                :visible="showModal"
                size="sm"
                @onPrimaryClick="() => { showModal = false; $emit('onClick')}"
                @onSecondaryClick="() => { showModal = false }">
            <div class="mx-3">{{confirmText}}</div>
        </inter-modal>
    </div>
</template>

<script>
    import InterModal from "../modal/InterModal";
    export default {
        name: "InterTableButton",
        components: {InterModal},
        data() {
            return {
                buttons: {
                    primary: {
                        label: 'Procedi',
                    },
                    secondary: {
                        label: 'Annulla',
                    }
                },
                showModal: false
            }
        },
        props: {
            icon: {
                type: String,
                default: ''
            },
            enabled: {
                type: Boolean,
                default: true
            },
            toConfirm: {
                type: Boolean,
                default: false
            },
            styleBtn: {
                type: String,
                default: 'primaryButton'
            },
            confirmTitle: {
              type: String,
              default: 'Conferma azione'
            },
            confirmText: {
              type: String,
              default: 'Sei proprio sicuro ?'
            },
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        methods: {
            onClick() {
                if(this.toConfirm) {
                    this.showModal = true;
                } else {
                    this.$emit('onClick');
                }

            }
        }
    }
</script>

<style scoped>

</style>
